var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:`${_vm.textColor}--text`},[_vm._v(" "+_vm._s(`${_vm.selectModel(_vm.modelValue, _vm.valueDataSelectorKey)} / ${_vm.selectModel(_vm.modelValue, _vm.totalDataSelectorKey)}`)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }